import React from 'react';
import App from './app.component';
import { withRouter, Router } from 'react-router';
import { withRxJs } from '../../components/hoc/with-rx';
import { History } from 'history';
import { UserApi } from '../../apis/user.api';
import { none } from 'fp-ts/lib/Option';
import { LeadApi } from '../../apis/lead.api';
import { AppApi } from '../../apis/app.api';
import { merge, of } from 'rxjs';
import { RemoteDataUtils } from '@assetmark/ui-kit/dist/utils/remote-data.utils';
import { apiClientsErrors$ } from '../../apis/api.client';
import { AMPError } from '@assetmark/ui-kit/dist/utils/errors';
import { AjaxError } from 'rxjs-compat/observable/dom/AjaxObservable';
import { AnalysisApi } from '../../apis/analysis.api';

const AppRxContainer = withRxJs(App)(() => {
	const sync$ = merge(AppApi.sync$, LeadApi.sync$).subscribe();
	const applicationState$ = AppApi.appStateData$;
	const user$ = AppApi.isAuthCallComplete$.switchMap(isAuth => {
		if (isAuth) {
		return UserApi.getUser()
			.map(value => value.toOption())
			.do(user => user.map(u => AppApi.advisorId$.next(u.roles[0].aplId.getOrElse(''))));
		} else {
			return of(none);
		}
	});

	const isApiError$ = merge(apiClientsErrors$, AnalysisApi.errorSubj$)
		.do(err => console.log('apiClientsErrors$ :>> ', err))
		//.filter((err: AMPError): err is AjaxError => err instanceof AjaxError)
		//.filter((err: AjaxError) => err.status === 401 || err.status === 403)
		.mapTo(true)
		.startWith(false)
		.shareReplay(1);

	return {
		defaultProps: {
			isApiError: false,
			user: none,
			applicationState: RemoteDataUtils.initial,
			redirectToPage: '',
			savedLeadStrategiesData: RemoteDataUtils.initial,
			savedLeadGoalsData : RemoteDataUtils.initial,
			savedGoalsData: () => {
				//AppApi.getSavedGoalsData();
			}
		},
		props: {
			isApiError: isApiError$,
			user: user$,
			applicationState: applicationState$,
			redirectToPage: AppApi.getNextPageToRedirect$(), // this observable give the next page tobe redirected.
			savedLeadStrategiesData: AppApi.getSavedLeadStrategiesData$(),
			savedLeadGoalsData: AppApi.getGoalsData$(),
		},
	};
});

const AppWithRouter = withRouter(AppRxContainer);

export type TAppContainerProps = {
	history: History;
};

export const AppContainer: React.FC<TAppContainerProps> = ({ history }) => (
	<Router history={history}>
		<AppWithRouter />
	</Router>
);
